// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__XByzu","empty":"ModalGraph_empty__32TNj"};